import { Reason } from '../implementation';
export class AbortReason extends Reason {
    static discard(reason) {
        if (!(reason instanceof AbortReason)) {
            throw reason;
        }
    }
    constructor(message = 'Aborted') {
        super(message, 'ABORT');
    }
}
//# sourceMappingURL=abort-reason.js.map